import { EVENTS } from "@/mocks/events";
import SectionHeading from "./SectionHeading";

interface TopicsSectionProps {
  onPick: (category: string) => void;
}

const TOPIC_META: Record<string, string> = {
  全部: "逛遍本站全部已入库的吃瓜专题。",
  娱乐圈: "艺人动态、合约纠葛与行业内幕的一线风向。",
  饭圈观察: "圈层文化、控评与表达边界背后的集体行为学。",
  综艺内幕: "从剪辑到剧本，还原镜头之后的制作逻辑。",
  网红塌房: "直播与带货乱象的深度扒皮与行业透视。",
  商界八卦: "企业与舆情的攻防战，危机公关的复盘现场。",
  社会热议: "热搜机制与集体情绪，读懂正在刷屏的话题。",
};

export default function TopicsSection({ onPick }: TopicsSectionProps) {
  const goCategory = (cat: string) => {
    onPick(cat);
    document
      .getElementById("latest")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="topics"
      className="w-full bg-background-100 scroll-mt-24"
      aria-label="分类热词"
    >
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          icon="ri-price-tag-3-line"
          kicker="分类热词"
          title="按主题，挑一个感兴趣的圈层"
          desc="不同瓜局属于不同圈子。选择分类即可快速筛选下方最新速览中的相关事件。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {(
            [
              { key: "娱乐圈", icon: "ri-star-smile-line" },
              { key: "综艺内幕", icon: "ri-tv-2-line" },
              { key: "饭圈观察", icon: "ri-heart-3-line" },
              { key: "网红塌房", icon: "ri-smartphone-line" },
              { key: "商界八卦", icon: "ri-building-4-line" },
              { key: "社会热议", icon: "ri-earth-line" },
            ]
          ).map((cat, idx) => {
            const count = EVENTS.filter((e) => e.category === cat.key).length;
            return (
              <button
                key={cat.key}
                type="button"
                onClick={() => goCategory(cat.key)}
                className="group relative flex items-center gap-4 overflow-hidden rounded-2xl bg-background-50 p-5 text-left transition-all hover:-translate-y-1"
              >
                <span
                  className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl text-2xl ${
                    idx % 2 === 0
                      ? "bg-primary-100 text-primary-600"
                      : "bg-accent-100 text-accent-700"
                  } group-hover:bg-primary-500 group-hover:text-background-50 transition-colors`}
                >
                  <i className={cat.icon} aria-hidden="true"></i>
                </span>
                <span className="min-w-0">
                  <span className="flex items-center gap-2">
                    <span className="text-base font-bold text-foreground-950">
                      {cat.key}
                    </span>
                    <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-semibold text-secondary-800">
                      {count} 个专题
                    </span>
                  </span>
                  <span className="mt-1 line-clamp-2 block text-xs leading-relaxed text-foreground-600">
                    {TOPIC_META[cat.key]}
                  </span>
                </span>
                <i
                  className="ri-arrow-right-s-line ml-auto text-2xl text-foreground-300 transition-transform group-hover:translate-x-1 group-hover:text-primary-500"
                  aria-hidden="true"
                ></i>
              </button>
            );
          })}

          {/* 全部 */}
          <button
            type="button"
            onClick={() => goCategory("全部")}
            className="group flex items-center justify-center gap-3 rounded-2xl bg-primary-500 p-5 text-left text-background-50 transition-all hover:-translate-y-1 hover:bg-primary-600"
          >
            <i className="ri-apps-2-line text-2xl" aria-hidden="true"></i>
            <span className="font-display text-lg">逛遍全部专题</span>
            <span className="rounded-full bg-background-50/20 px-2 py-0.5 text-xs">
              {EVENTS.length} 个
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}